module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-big-down/wow-fade-in-big-down.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-big-down/wow-fade-in-big-down.component.scss
// module chunks = main